import { call, put, takeLatest } from 'redux-saga/effects';
import { Posts } from 'services/api';
import { posts, postsSuccess, postsFailure } from '../../actions';
import { actions as notificationActions } from 'components/Notification';

function* getPostsSaga(action) {
  try {
    const { data } = yield call(Posts.index, action.payload);
    yield put(postsSuccess(data));
  } catch (e) {
    yield put(postsFailure(e.data));
    yield put(
      notificationActions.addNotification(
        e.data.errors.map(error => ({ type: 'error', message: error.code }))
      )
    );
  }
}

export default () => takeLatest(posts, getPostsSaga);
